// extracted by mini-css-extract-plugin
module.exports = {"overlay":"overlay_overlay__1cbTl","blur":"overlay_blur__3meGK","light":"overlay_light__Uzus-","dark":"overlay_dark__1XGuR"};